export default __webpack_public_path__ + "static/media/scrollTop.0350bb76.svg";